import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { CommonService } from 'src/app/lib/services/common.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-options-menu',
  templateUrl: './options-menu.component.html',
  styleUrls: ['./options-menu.component.scss'],
  standalone: false
})
export class OptionsMenuComponent implements OnInit {

  @Input() shopId: any;
  @Input() vendDetails: any;
  addDisable: boolean = false;

  constructor(
    private modalCtrl: ModalController,
    public commonService: CommonService,
    private router: Router
  ) { }

  ngOnInit() { }

  action(arg: any) {
    return this.modalCtrl.dismiss(arg);
  }

  share(arg: any) {
    this.commonService.featureNotAvailable();
  }

  sellerProfile(details: any) {
    this.router.navigate([`/seller-profile/${details.shop_id}`], {
      queryParams: {
        vendorDetails: JSON.stringify(details)
      }
    });
    this.action('close')
  }
}

